import { apicall } from '../../services/api';
import {GETDATA} from '../actions/actionTypes';



export const getAllCampaigns = (data) => async (dispatch) => {
    const {page,limit,search}=data
	try {
		 const res = await apicall(`/dash/getAll?page=${page}&limit=${limit}&search=${search}`,"get");
		dispatch({
			type: GETDATA,
			payload: res.data?.data,
		});
        return  res.data?.data
	} catch (err) {
		dispatch({
			type: GETDATA,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
	}
};
